import EventCard from "./EventCard";
import { PimsEvent } from "../types";

interface EventListProps {
  events: PimsEvent[];
  selectedEvents: Set<string> | string;
  onEventSelection: (eventId: string, checked: boolean) => void;
  selectionMode?: "checkbox" | "radio";
  radioName?: string;
  size?: "small" | "medium";
  gridCols?: string;
}

export default function EventList({
  events,
  selectedEvents,
  onEventSelection,
  selectionMode = "checkbox",
  radioName,
  size = "medium",
  gridCols = "grid-cols-1 md:grid-cols-2 lg:grid-cols-3",
}: EventListProps) {
  const isEventSelected = (eventId: string) => {
    if (selectionMode === "radio") {
      return selectedEvents === eventId;
    }
    return (selectedEvents as Set<string>).has(eventId);
  };

  if (events.length === 0) {
    return (
      <div className="text-center text-muted-foreground py-8">
        Aucun évènement trouvé
      </div>
    );
  }

  return (
    <div className={`grid ${gridCols} gap-4`}>
      {events.map((event) => {
        if (!event) return null;

        return (
          <EventCard
            key={event.id}
            event={event}
            isSelected={isEventSelected(event.id)}
            onSelectionChange={onEventSelection}
            selectionMode={selectionMode}
            radioName={radioName}
            size={size}
          />
        );
      })}
    </div>
  );
}
